module.exports = __webpack_public_path__ + "static/media/xiaojiacheck.bcef10a5.png";